import React from 'react'
import PropTypes from 'prop-types'

const Cell = ({ time, title, start, end }) => {
  const day = start.getDay()
  const isWeekend = day === 0 || day === 6
  return (
    <div
      className={`rt-timebar__cell${isWeekend ? ' rt-timebar__cell--weekend' : ''}`}
      style={time.toStyleLeftAndWidth(start, end)}
    >
      {title}
    </div>
  )
}

Cell.propTypes = {
  time: PropTypes.shape({
    toStyleLeftAndWidth: PropTypes.func,
  }),
  title: PropTypes.string.isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
}

export default Cell
